import React from "react";

const hiddenValuesMask = {
    price: "xx xxx,xx ₽",
    pricePerVal: "xx,xx ₽",
    docNumber: "xxxxxxxxxx",
    phone: "+7xxxxxxxxx",
    title: "xxxxxxxxx",
    percent: "xx.xx%",
    default: "xxxxxx",
};

export const HiddenDataWrapper = ({ hidden, children }: { hidden: boolean; children: React.ReactNode }) => {
    return isHidden(hidden) ? null : children || null;
};

export const isTechSupport = () => localStorage.getItem("isTechSupport") === "true";

export const isHidden = (hidden?: boolean) => hidden || isTechSupport();

export const hiddenUserData = (
    value: any,
    options: { valueMask?: string; type: keyof typeof hiddenValuesMask; default?: any },
    hidden?: boolean,
) => {
    if (!isHidden(hidden)) {
        return value;
    }
    if (options?.valueMask) {
        return options.valueMask;
    }
    return hiddenValuesMask[options?.type] || hiddenValuesMask.default;
};
